/**
 * Registering the service worker.
 *
 * Production only. A service worker in front of the dev server caches assets Vite is trying to
 * hot-replace, which turns every edit into a puzzle.
 */

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) {
    return;
  }

  // After load, so registering never competes with the first paint for bandwidth.
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // An app that works online but failed to arrange working offline is still an app that
      // works. Nothing here is worth interrupting anyone about.
    });
  });
}
